import Vue from 'vue'
import App from './App.vue'
import $ from 'jquery'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui';

import md5 from 'js-md5'
Vue.prototype.$md5 = md5
//请求
import axios from 'axios'
Vue.prototype.$axios = axios
import VueAxios from 'vue-axios'
// 引用API文件
import api from './api'
Vue.prototype.$api = api
//路由
import VueRouter from 'vue-router'
import router from './router'
//Vuex
import store from './store'

import Cookies from 'js-cookie'
Vue.prototype.$Cookies = Cookies


Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(VueAxios, axios)
Vue.config.productionTip = false



new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
